import React from 'react';
import './App.scss';
import { HashRouter, Route, Routes } from 'react-router-dom';
import HotelListPage from './pages/hotel/list/HotelListPage';
import HotelDetailPage from './pages/hotel/detail/HotelDetailPage';
import reducers from './state/reducer';
import { INITIAL_STATE as HOTEL_DETAIL_INITIAL_STATE } from './state/hotel-detail/reducer';
import { INITIAL_STATE as BOOKING_INITIAL_STATE } from './state/booking/reducer';
import { INITIAL_STATE as ROOM_RATE_INITIAL_STATE } from './state/room-rate/reducer';
import { StateProvider } from './state';
import UsePageTracking from './helper/tracking';
import AffiliatesPage from './pages/affiliates';
import RedirectPage from './pages/RedirectPage';

function App() {
  const initialState = {
    hotel: HOTEL_DETAIL_INITIAL_STATE,
    booking: BOOKING_INITIAL_STATE,
    roomRate: ROOM_RATE_INITIAL_STATE,
  };
  return (
    <>
      <StateProvider initialState={initialState} reducer={reducers}>
        <HashRouter>
          <UsePageTracking />
          <Routes>
            <Route path="/" element={<RedirectPage />} />
            <Route path="/affiliates" element={<AffiliatesPage title="affiliate" />} />
            <Route path="/ambassadors" element={<AffiliatesPage title="ambassador" />} />
            <Route path="/hotel" element={<HotelListPage />} />
            <Route path="/activities" element={<HotelListPage />} />
            <Route path="/hotel/:hotelId" element={<HotelDetailPage />} />
          </Routes>
        </HashRouter>
      </StateProvider>
    </>
  );
}

export default App;
